/**
 * List of options for the RFID Reader Emulation Mode field
 *
 * @namespace tmrRfidReaderEmulatorModes
 * @type {ngConstant}
 */
export const constant = [
  'tmrRfidReaderEmulatorModes',
  {
    RANDOM_EPC: 'ADMIN.RFIDREADERS.EMULATORMODERANDOM',
    EPC_LIST: 'ADMIN.RFIDREADERS.EMULATORMODELIST',
  },
]

/**
 * Translates {@link tmrRfidReaderEmulatorModes}
 *
 * @type {ngRun}
 */
let tmrRfidReaderEmulatorModesRun = /*@ngInject*/ (
  TmrTranslate,
  tmrRfidReaderEmulatorModes
) => TmrTranslate.object(tmrRfidReaderEmulatorModes)

export { tmrRfidReaderEmulatorModesRun as run }
